import Section from '../Section';

export default class FooterNewsletter extends Section {

}
